































export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    recordType: {
      type: String,
      default: 'Record',
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    confirmDeleteAction() {
      this.$emit('confirmDeleteAction')
    },
  },
}
